import { routeData } from "@/router/constants/routes";
import { isVerifiedInsurance } from "@/router/methods/helpers/requires-verified-redirect";

export async function insuranceCompanyBeforeEnter(to, from) {
    if (isVerifiedInsurance()) {
        return {
            name: routeData.HERITAGE.name,
            replace: true,
        };
    }
}
